export default __webpack_public_path__ + "static/media/sustainingwrath.979cf964.png";